export function Logo({
  name = 'Raffles',
  sub = 'RAFFLE ENGINE',
  accentClass = 'teal',
}: {
  name?: string;
  sub?: string;
  accentClass?: string;
}) {
  return (
    <div className="logo">
      <div className="orb" />
      <div className="wordmark">
        <div className="word">
          Flux<span className={`accent ${accentClass}`}> {name}</span>
        </div>
        <div className="sub">{sub}</div>
      </div>
    </div>
  );
}
